import React, { PureComponent, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Card, CardBody, Label, Button } from 'reactstrap';
import ReactTable from 'react-table';
import { Colxx, Separator } from 'Components/CustomBootstrap';
import BreadcrumbContainer from 'Components/BreadcrumbContainer';
import DataTablePagination from 'Components/DataTables/pagination';
import {
	couponCategoriesFindAllByPageAndOptions,
	errorReset,
} from 'Redux/actions';
import * as couponCategoriesReducer from 'Redux/couponCategories/reducer';
import IntlMessages from 'Util/IntlMessages';

class PageCouponCategories extends PureComponent {
	constructor() {
		super();
		this.state = {
			keyword: '',
			tableState: {},
		};
		this.breadcrumb = [
			{ id: 'menu.coupon.manage-categories', href: '/coupon-category/list' },
		];
		this.columns = [
			{
				id: 'category',
				Header: 'Category',
				accessor: (d) => (
					<NavLink to={`/app/coupon-category/edit/${encodeURIComponent(d.category)}`}>
						{d.category}
					</NavLink>
				),
			},
			{
				Header: 'Description',
				accessor: 'description',
			},
			{
				id: 'shop_count',
				Header: 'Shops',
				width: 80,
				sortable: false,
				accessor: (d) => d.shop_count,
			},
			{
				id: 'action',
				Header: '',
				width: 50,
				sortable: false,
				accessor: (d) => (
					<NavLink className="btn btn-xs btn-outline-primary" to={`/app/coupon-category/edit/${encodeURIComponent(d.category)}`}>
						<i className="simple-icon-pencil" />
					</NavLink>
				),
			},
		];
		this.fetchData = this.fetchData.bind(this);
		this.onChangeKeywordHandler = this.onChangeKeywordHandler.bind(this);
		this.onSubmitHandler = this.onSubmitHandler.bind(this);
	}

	componentDidMount() {
		this.props.errorReset('couponCategory');
	}

	fetchData(state) {
		const { keyword } = this.state;

		let params = {
			page: state.page + 1,
			size: state.pageSize,
		};
		if (state.sorted && state.sorted.length > 0) {
			params.sort_column = state.sorted[0].id;
			params.sort_direction = state.sorted[0].desc ? 'desc' : 'asc';
		}
		if (keyword) {
			params.keyword = keyword;
		}

		this.setState({ tableState: state });
		this.props.couponCategoriesFindAllByPageAndOptions(params);
	}

	onChangeKeywordHandler(e) {
		this.setState({ keyword: e.target.value });
	}

	onSubmitHandler(e) {
		e && e.preventDefault();
		const { tableState } = this.state;
		this.fetchData(tableState);
	}

	render() {
		const { couponCategoriesByPage } = this.props;
		const { keyword } = this.state;
		const listStatus = this.props.status.get('couponCategories');
		const isLoading = listStatus === 'fetching';

		return (
			<Fragment>
				<Row>
					<Colxx xxs="12">
						<div className="float-left">
							<BreadcrumbContainer
								heading={<IntlMessages id="couponCategories.heading" />}
								items={this.breadcrumb}
								match={this.props.match}
							/>
						</div>
						<div className="float-right">
							<NavLink to="/app/coupon-category/create" className="btn btn-lg btn-primary">
								CREATE NEW
							</NavLink>
						</div>
						<div className="clearfix"></div>

						<form className="mb-3" onSubmit={this.onSubmitHandler}>
							<Row className="align-items-center">
								<Colxx xxs="12" md="6">
									<Label>Search:</Label>
									<div className="search-sm d-inline-block w-100">
										<input
											type="text"
											placeholder="Search by category or description"
											className="w-100"
											value={keyword}
											onChange={this.onChangeKeywordHandler}
										/>
									</div>
								</Colxx>
								<Colxx xxs="12" md="6" className="text-right mt-4">
									<Button color="primary" type="submit">
										Search
									</Button>
								</Colxx>
							</Row>
						</form>
					</Colxx>
				</Row>

				<Separator className="mb-5" />

				<Row>
					<Colxx xxs="12">
						<Card>
							<CardBody>
								<ReactTable
									manual
									data={couponCategoriesByPage.get('data')}
									pages={couponCategoriesByPage.get('max_page')}
									loading={isLoading}
									onFetchData={this.fetchData}
									columns={this.columns}
									minRows={0}
									showPageJump={true}
									showPageSizeOptions={true}
									PaginationComponent={DataTablePagination}
								/>
							</CardBody>
						</Card>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

export default connect(
	couponCategoriesReducer.selector,
	{
		couponCategoriesFindAllByPageAndOptions,
		errorReset,
	}
)(PageCouponCategories);
